// C1 Level Aggregator - Advanced
// Tüm C1 ünite içeriklerini birleştirir

import { C1_UNIT_1 } from './kariyerContentsC1Unit1';
import { C1_UNIT_2 } from './kariyerContentsC1Unit2';
import { C1_UNIT_3 } from './kariyerContentsC1Unit3';
import { C1_UNIT_4 } from './kariyerContentsC1Unit4';
import { C1_UNIT_5 } from './kariyerContentsC1Unit5';
import { C1_FINAL } from './kariyerContentsC1Final';

export const C1_LEVEL = {
  ...C1_UNIT_1,  // Perfect Tenses Advanced
  ...C1_UNIT_2,  // Third Conditional
  ...C1_UNIT_3,  // Advanced Modal Verbs
  ...C1_UNIT_4,  // Complex Sentences & Report Writing
  ...C1_UNIT_5,  // Professional Communication Mastery
  ...C1_FINAL,   // Final Sınavı
};

export default C1_LEVEL;
